<template>
  <div class="message-inifity-scroll__container">
    <MessagePreview
      v-for="item in items"
      :key="item.messageId" 
      :value=item
    />
    <div class="d-flex justify-content-center">
      <ActionButton
        v-if="!isLastPage"
        @click="handleViewMore"
        i="fas fa-angle-double-down"
        variant="success"
        text="Ver Más"
        style="width: 99%;"
      />
    </div>
  </div>
</template>

<script>
import MessagePreview from './MessagePreview';
import ActionButton from 'ActionButton';
import { fetchMessages } from '@/api/message.api';

export default {
  name: 'MessageInifityScroll',
  components: {
    ActionButton,
    MessagePreview
  },
  props: {
  },
  data() {
    return {
      pageSize: 10,
      pageIndex: 0,
      lastPageIndex: 0,
      items: [],
    };
  },
  methods: {
    async handleViewMore() {
      this.pageIndex++;
      const payload = {
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      };

      const { data } = await fetchMessages(payload);
      this.items = [...this.items, ...data.data];
      this.lastPageIndex = data.pageCount;
    }
  },
  computed: {
    isLastPage() {
      return this.pageIndex === this.lastPageIndex;
    }
  },
  async mounted() {
    await this.handleViewMore();
  },
};
</script>

<style scoped>
.message-inifity-scroll__container {
    width: 100%;
    height: 465px;
    margin: 0 10px;
    overflow-y: auto;
}
</style>